<app-main-nav-bar></app-main-nav-bar>

<router-outlet></router-outlet>

<app-footer></app-footer>


